import { ReactNode } from "react";

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  center?: boolean;
  children?: ReactNode;
  className?: string;
}

const SectionTitle = ({ 
  title, 
  subtitle, 
  center = true, 
  children,
  className = "" 
}: SectionTitleProps) => {
  return (
    <div className={`space-y-3 ${center ? 'text-center mx-auto' : ''} max-w-3xl ${className}`}>
      <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 opacity-0 animate-fade-in">
        {title}
      </h2>
      {subtitle && (
        <p className="text-lg text-gray-600 opacity-0 animate-fade-in animate-delay-100">
          {subtitle}
        </p>
      )}
      {children}
    </div>
  );
};

export default SectionTitle;